export default __webpack_public_path__ + "static/media/partner-dimuto1.ed52e81a.png";